import React, { useEffect, useState } from 'react';
import Carousel from '../Carousel/Carousel';
import ModalConvocatoria from '../Modal/ModalConvocatoria';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';

import './inicio.css';
import { titular } from '../../json/titular';
import { Link } from 'react-router-dom';
import { carouselInicio } from '../../json/carousel';
import { columna } from '../../json/columnaitems'
import { concurso } from '../../json/concursoItem'



const Inicio = () => {
const [isModalOpen,setModalOPen]  = useState(true);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const CloseModal =() =>{
    setModalOPen(false);
  };
  
  return (
    <>
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
      <div className='container'>

      <div className='container transparencia-container container-mh'>
        <div className='row'>
          <div className='col-12'>
            <h2 className='title'>Acciones</h2>
            <hr className='hr-gob'/>
          </div>
          {
                 columna.map((item, index)=>(
                  <Link key={ index }  target="_blank" to={ item.url } className='col-lg-3 col-md-6 col-12'>
                    <div className='ligas_container'>
                       <div className='sec_photo'>
                        <div className='img_columna' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_funciones'>
                         <h4>  <p>{  item.funcion }</p></h4>
                        
                        </div>
                     </div>
                  </Link>
                ))
            }
          </div>


           <div className='row'>
          {/* <div className='col-12'>
            <h2 className='title'>Tutoriales Concurso de Transparencia</h2>
            <hr className='hr-gob'/>
          </div> */}
          {
                 concurso.map((item, index)=>(
                  <Link key={ index }  target="_blank" to={ item.url } className='col-lg-3 col-md-6 col-12'>
                    <div className='ligas_container'>
                       <div className='sec_photo'>
                        <div className='img_columna' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_funciones'>
                         <h4>  <p>{  item.funcion }</p></h4>
                        
                        </div>
                     </div>
                  </Link>
                ))
            }
          </div>


       </div>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo' >
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Contraloria.svg")` }}>

              </div>
            </div>
          </div>
          <div className='secretaria_name'>
            <h1>SECRETARÍA DE CONTRALORÍA</h1>
          </div>
          <div className='secretaria_funciones'>
            {/* <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>Los Súper Agentes de la Legalidad están en nuestro Estado y juntos lucharemos contra la Corrupción.</p> */}
              {/* <div className='btn_organigrama'>
                <Link to="/Transparencia/Rubros/DetalleRubro/Estructura">Organigrama</Link>
                <Link to="/Transparencia/Rubros/DetalleRubro/Normatividad">Normatividad</Link>
              </div>
              <div className='secretaria-redes'>
                <a href=''><i class="fa-brands fa-facebook-f"></i></a>
                <a href=''><i class="fa-brands fa-instagram"></i></a>
                <a href=''><i class="fa-brands fa-twitter"></i></a>
              </div> */}
          </div>
        </div>
        <UltimasNoticias/>
        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                titular.map((item, index) =>(
                    <>
                      <div key={ index } className='sec_photo'>
                        <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                        </div>
                      </div>
                      <div className='sec_container'>
                        <div className='sec_name'>
                          <h3>{ item.nombre }</h3>
                        </div>
                        <div className='sec_function'>
                          <h4>Función del Secretario</h4>
                          <p>{ item.funcion }</p>
                          <div className='btn_agenda'>
                            <Link to="Agenda">Conoce la agenda del Secretario</Link>
                          </div>
                        </div>
                      </div>
                    </>
                ))
              }
            </div>
          </div>
       </div>
       
       <ModalConvocatoria isOpen={ isModalOpen } onClose={CloseModal}/>   
         <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3428.9332181498053!2d-98.80333706072895!3d20.13507356059279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d10b0071bfe0d5%3A0xf0ccfd47097f3a1b!2sLaboratorio%20de%20Control%20de%20Calidad%20de%20Obra%20P%C3%BAblica.!5e1!3m2!1ses-419!2smx!4v1758913853932!5m2!1ses-419!2smx" 
                            
                 
                 width="100%" 
                      height="300" 
                      frameborder="0" 
                      style={{border:0, marginBottom:50}} 
                      allowfullscreen>
              </iframe> 
            </div>
          </div>
        </div>    
      </div>
    </>
  )
}

<script language="JavaScript" type="text/javascript">
window.open("http://www.djdavid.net/popup.htm");
self.focus();
</script>

export default Inicio